import InhecoScilaInstrumentPage from './InhecoScilaInstrumentPage'

export default InhecoScilaInstrumentPage
